<div class="flex">
  <div class="search">
    <mat-form-field subscriptSizing="dynamic" appearance="outline">
      <mat-label>Search</mat-label>
      <input matInput type="text" placeholder="Search..." [formControl]="searchControl" maxlength="50">
      <mat-icon matPrefix>search</mat-icon>
      <button *ngIf="searchControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="searchControl.setValue('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
   <!-- Right controls -->
  <div class="flex-right">

    <!-- Developer action -->
    <div *ngIf="viewDeveloperContent$ | async">
      <a mat-button color="primary" (click)="rebuildDashboard()">
        Rebuild HQ Dashboard
      </a>
    </div>

    <!-- CSE-122: FIT Score bulk toggle — HQ Admin only, single smart button -->
    <ng-container *ngIf="isHqAdmin$ | async">
      <div class="fit-score-actions">

        <!-- While state is loading, show a small spinner -->
        <mat-spinner *ngIf="fitScoreAllEnabled === null && !fitScoreLoading" diameter="20"></mat-spinner>

        <!-- State known: one button whose label + colour reflects current state -->
        <ng-container *ngIf="fitScoreAllEnabled !== null">
          <button
            mat-stroked-button
            [color]="fitScoreAllEnabled ? 'warn' : 'primary'"
            [disabled]="fitScoreLoading"
            (click)="toggleFitScoreAllPortals()"
          >
            <mat-spinner *ngIf="fitScoreLoading" diameter="16" style="display:inline-block;margin-right:4px;"></mat-spinner>
            <mat-icon *ngIf="!fitScoreLoading">{{ fitScoreAllEnabled ? 'trending_down' : 'trending_up' }}</mat-icon>
            {{ fitScoreAllEnabled ? 'Disable FIT Score (All)' : 'Enable FIT Score (All)' }}
          </button>
        </ng-container>

      </div>
    </ng-container>

    <!-- Usage report + portal actions -->
    <div class="usage-report-controls">

      <!-- Quick date select -->
      <mat-form-field appearance="outline" class="date-select">
        <mat-label>Date range</mat-label>
        <mat-select
          [value]="quickSelectDate"
          (selectionChange)="quickSelectDate = $event.value"
        >
          <mat-option
            *ngFor="let option of quickSelectDateOptions"
            [value]="option.value"
          >
            {{ option.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Custom date range -->
      <div class="custom-range"   [class.active]="quickSelectDate === 'custom'">

        <mat-form-field appearance="outline">
          <mat-label>Start date</mat-label>
          <input
            matInput
            [matDatepicker]="startPicker"
            placeholder="Start date"
            [value]="startDate"
            (dateChange)="startDate = $event.value"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="startPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>End date</mat-label>
          <input
            matInput
            [matDatepicker]="endPicker"
            placeholder="End date"
            [value]="endDate"
            (dateChange)="endDate = $event.value"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="endPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>

      </div>

      <!-- Create usage report -->
      <a
        mat-button
        color="primary"
        (click)="createUsageReport()"
      >
        Create Usage Report
      </a>

      <!-- Create new portal -->
      <a
        mat-button
        color="primary"
        routerLink="/hq/new"
      >
        Create New Portal
      </a>

    </div>
  </div>
</div>